import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import DatePicker from "react-datepicker";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import Button from "react-validation/build/button";
import { NavLink, Redirect, Link } from "react-router-dom";
import {
  clearUpdate,
  getQualificationConfigurationByFormId,
  getAllDocumentChecklistByFormId,
  admissionAcademicProfileInsert,
  getAllQuota,
  getAllAdmissionProgramByFormId,
  getAllAdmissionFormConfigurationByFormId,
  getAllAdmissionSubjectGroupByFormId,
  getWorkingInstituteDetailsByStudentId,
  getOtherDetailsByStudentId,
  getResearchDetailsByStudentId,
  getExperienceDetailsByStudentId,
  getAcademicQuotaDetailsByStudentId,
  getFormVerifyDetailsByStudentId,
  getAllApplyThroughList,
  getAllBoardList,
  getAllMarksTypeList,
  getACPCdetailsByStudentId,
  getAllAdmissionFormListByStudentId,
  getStudentStatusDetailsByUserId,
} from "../../actions";
import updateGrid from "../../utils/updateGrid";
import * as validations from "../lib/validations";
import { FileInput } from "../lib/FileInputHOC";
import fileToBase64 from "../../utils/fileTobase64";
import SelectAdvance from "react-select";
import textToCapitalize from "../../utils/textToCapitalize";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const keys = require("../../config/keys");

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  background: isDragging ? "antiquewhite" : "white",
  ...draggableStyle,
});
const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver && "white",
});

class AcademicInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allExperienceData: [],
      allResearchData: [],
      allDocumentList: [],
      allQualification: [],
      selectedPrograms: [],
      admissionProgram: [],
      allSubjectGroup: [],
      selectedQuota: [],
      academicQuota: [],
      admissionTypeId: 1,
      programRequired: false,
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }
  async componentWillMount() {
    this.props.getAllApplyThroughList();
    this.props.getAllBoardList();
    this.props.getAllMarksTypeList();

    // this.props.getAllAdmissionFormListByStudentId(this.props.auth.userId);
    // this.props.getStudentStatusDetailsByUserId(this.props.auth.userId);
    this.props.getAllAdmissionFormListByStudentId(
      this.props.auth.userId,
      this.props.auth.admissionConfig.AyId
    );
    this.props.getStudentStatusDetailsByUserId(
      this.props.auth.userId,
      this.props.auth.admissionConfig.AyId
    );

    const PromiseArry = [];

    if (this.props.FormId) {
      this.props.getAllAdmissionFormConfigurationByFormId(this.props.FormId);
      this.props.getAllQuota(this.props.FormId);
      PromiseArry.push(
        this.props.getFormVerifyDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getWorkingInstituteDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getOtherDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getResearchDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getExperienceDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getACPCdetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAllAdmissionSubjectGroupByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAllAdmissionProgramByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getQualificationConfigurationByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAllDocumentChecklistByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAcademicQuotaDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );

      await Promise.all(PromiseArry);

      // var otherdata = this.props.qualificationConfigList;
      var fromDataList = _.uniqBy(
        this.props.qualificationConfigList,
        "Qualification_ID"
      );
      var tempData = [];
      fromDataList.map((qual) => {
        var obj = { ...qual };
        var a = this.props.qualificationConfigList.filter(
          (i) =>
            i.Qualification_ID === qual.Qualification_ID &&
            i.ShowInDetailTable === 1
        );
        obj["subjectList"] = a;
        tempData.push(obj);
        return obj;
      });

      var subjectDataList = this.props.admissionSubjectGroupList.map((i) => {
        return i;
      });
    }

    var admissionProgram = this.props.admissionProgram.map((item) => {
      item.value = parseInt(item.CourseID, 10);
      item.label = item.ProgramName;
      item.disabled = item.AdmOpenCloseStatus ? true : false;
      item.clearableValue = item.AdmOpenCloseStatus ? false : true;
      return item;
    });

    var admTypeID;
    if (this.props.admissionProgram.length > 0) {
      admTypeID = this.props.admissionProgram[0].AdmissionType;
    }

    var academicQuota = _.sortBy(this.props.quotaList, "AdmQuota").map(
      (item) => {
        item.value = parseInt(item.AdmQuotaId, 10);
        item.label = item.AdmQuota;
        return item;
      }
    );
    var selectedQuota = _.sortBy(this.props.academicQuotaList, "AdmQuota").map(
      (item) => {
        item.value = parseInt(item.AdmQuotaId, 10);
        item.label = item.AdmQuota;
        return item;
      }
    );

    await this.setState({
      allDocumentList: _.sortBy(this.props.documentChecklist, "SeqNo"),
      allQualification: tempData,
      admissionProgram: admissionProgram,
      selectedPrograms: admissionProgram.filter((i) => parseInt(i.Id, 10)),
      allSubjectGroup: subjectDataList,
      selectedQuota: selectedQuota,
      admissionTypeId: admTypeID !== 0 ? admTypeID : 1,
      academicQuota: academicQuota,
      allExperienceData: this.props.admissionExperienceDetails,
      allResearchData: this.props.admissionResearchDetails,
    });

    if (this.props.admissionACPCdetails.length > 0) {
      await this.setState({
        acpcId: this.props.admissionACPCdetails[0].Id,
        registrationNo: this.props.admissionACPCdetails[0].RegistrationNo,
        meritNo: this.props.admissionACPCdetails[0].MeritNo,
      });
    }
    if (this.props.admissionOtherDetails.length > 0) {
      await this.setState({
        isHostel:
          this.props.admissionOtherDetails[0].IsHostel === 1 ? true : false,
        isTransport:
          this.props.admissionOtherDetails[0].IsTransport === 1 ? true : false,
        otherDetailId: this.props.admissionOtherDetails[0].Id,
        proposedArea: this.props.admissionOtherDetails[0].ResearchArea_Title,
      });
    }
    if (this.props.admissionWorkingDetails.length > 0) {
      await this.setState({
        nameOfDepartment: this.props.admissionWorkingDetails[0].DepartmentName,
        institution: this.props.admissionWorkingDetails[0].InstituteName,
        dateOfAppointment:
          this.props.admissionWorkingDetails[0].AppointmentDate !== null
            ? moment(this.props.admissionWorkingDetails[0].AppointmentDate)
            : undefined,
        designation: this.props.admissionWorkingDetails[0].DesignationName,
        periodOfService: this.props.admissionWorkingDetails[0].ServicePeriod,
        isNOCenclosed:
          this.props.admissionWorkingDetails[0].IsNOCenclosed === 1
            ? true
            : false,
      });
    }
  }

  /// Select DragDropContext
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  removeSelectedProgram = (index) => {
    this.state.selectedPrograms.splice(index, 1);
    this.setState({ selectedPrograms: this.state.selectedPrograms });
  };
  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const selectedPrograms = this.reorder(
      this.state.selectedPrograms,
      result.source.index,
      result.destination.index
    );
    this.setState({
      selectedPrograms: selectedPrograms,
    });
  }

  handleQuotaChange = (selectedQuota) => {
    this.setState({ selectedQuota });
  };

  onSwitchToggle = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  };
  appointmentDate = (date) => {
    this.setState({
      dateOfAppointment: date,
    });
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  // ExperienceData
  addExperienceData = async (e) => {
    e.preventDefault();
    if (
      this.state.position !== undefined &&
      this.state.organisation !== undefined
    ) {
      var experienceDatas = this.state.allExperienceData.filter((item) => {
        return (
          item.Position.toLowerCase().trim() ===
            this.state.position.toLowerCase().trim() &&
          item.Organisation.toLowerCase().trim() ===
            this.state.organisation.toLowerCase().trim()
        );
      });
      if (experienceDatas.length === 0) {
        const experienceConfig = {
          Position: this.state.position,
          Organisation: this.state.organisation,
          WorkDetails: this.state.workDetails,
          WorkDuration: this.state.workDuration,
        };
        await this.setState({
          allExperienceData: [
            ...this.state.allExperienceData.filter(
              (item) =>
                item.Position.toLowerCase().trim() !==
                  this.state.position.toLowerCase().trim() ||
                item.Organisation.toLowerCase().trim() !==
                  this.state.organisation.toLowerCase().trim()
            ),
            experienceConfig,
          ],
        });
      }
    }
    await this.setState({
      position: "",
      organisation: "",
      workDetails: "",
      workDuration: "",
    });
  };
  experienceConfigDelete = (eIndex) => {
    var array = this.state.allExperienceData;
    array.splice(eIndex, 1);
    this.setState({
      allExperienceData: array,
      position: "",
      organisation: "",
      workDetails: "",
      workDuration: "",
    });
  };

  // ResearchData
  addResearchData = async (e) => {
    e.preventDefault();
    if (
      this.state.publication !== undefined &&
      this.state.nameofJournal !== undefined &&
      this.state.researchType !== undefined
    ) {
      var researchDatas = this.state.allResearchData.filter((item) => {
        return (
          item.PublicationTitle.toLowerCase().trim() ===
          this.state.publication.toLowerCase().trim()
        );
      });
      if (researchDatas.length === 0) {
        const researchConfig = {
          PublicationTitle: this.state.publication,
          JournalName_Published: this.state.nameofJournal,
          No_Vol_Edition_Date: this.state.volEdition,
          ResearchType: this.state.researchType,
        };
        await this.setState({
          allResearchData: [
            ...this.state.allResearchData.filter(
              (item) =>
                item.PublicationTitle.toLowerCase().trim() !==
                this.state.publication.toLowerCase().trim()
            ),
            researchConfig,
          ],
        });
      }
    }
    await this.setState({
      publication: "",
      nameofJournal: "",
      volEdition: "",
      researchType: "",
    });
  };
  researchConfigDelete = (eIndex) => {
    var array = this.state.allResearchData;
    array.splice(eIndex, 1);
    this.setState({
      allResearchData: array,
      publication: "",
      nameofJournal: "",
      volEdition: "",
      researchType: "",
    });
  };

  onInputQualificationChange = (Qualification_ID, column, e) => {
    this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0][column] = e.target.value;

    this.setState({ refresh: !this.state.refresh });
  };

  onInputSubjectChange = (Qualification_ID, Qual_SubjectID, column, e) => {
    var filterQualification = this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0];
    var filteredSubject = filterQualification.subjectList.filter(
      (i) => i.Qual_SubjectID === Qual_SubjectID
    )[0];
    filteredSubject[column] = e.target.value;

    filteredSubject["TotalMarks"] =
      parseInt(filteredSubject["MarksTotal_Theory"], 10) +
        parseInt(filteredSubject["MarksTotal_Practical"], 10) || 0;
    filteredSubject["TotalScored"] =
      parseInt(filteredSubject["MarksScored_Theory"], 10) +
        parseInt(filteredSubject["MarksScored_Practical"], 10) || 0;
    this.setState({ refresh: !this.state.refresh });
  };

  onInputSubjectGroupChange = (SubGroupId, column, e) => {
    this.state.allSubjectGroup.filter((i) => i.SubGroupId === SubGroupId)[0][
      column
    ] = e.target.value;

    this.setState({ refresh: !this.state.refresh });
  };

  handleFileBrowseChange = (index, e) => {
    e.persist();

    var file_size;
    if (e.target.files[0] && e.target.files[0].size !== undefined) {
      file_size = e.target.files[0].size;
    }
    var DocState = this.state.allDocumentList;
    if (file_size <= 512000) {
      fileToBase64(e).then((data) => {
        DocState[index].file = {
          file: data.file,
          fileName: data.name,
        };
        DocState[index].ref = this["file" + index];
        this.setState({ ["file" + index + "fileSize"]: file_size });
      });
    } else {
      DocState[index].file = {
        file: null,
        fileName: null,
      };
      this.setState({
        ["file" + index + "fileSize"]: file_size,
      });
    }
  };

  handleProgramsChange = (selectedPrograms) => {
    this.setState({ selectedPrograms });
    if (selectedPrograms.length) {
      this.setState({ programRequired: false });
    } else {
      this.setState({ programRequired: true });
    }
  };

  handleAdmissionTypeChange = (selectedOption) => {
    var objAdmissionType = this.props.admissionApplyThrough.filter(
      (item) => item.Id === parseInt(selectedOption.target.value, 10)
    );
    if (objAdmissionType.length > 0) {
      this.setState({
        admissionTypeId: selectedOption.target.value || 1,
        admissionType: objAdmissionType[0].ApplyName || "",
      });
    }
  };
  renderAdmissionType = () => {
    return _.map(this.props.admissionApplyThrough, (data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.ApplyName}
        </option>
      );
    });
  };

  handleBoardChange = (Qualification_ID, column, e, University_Board) => {
    this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0][column] = parseInt(e.target.value, 10);
    this.setState({ refresh: !this.state.refresh });
  };
  renderBoard = () => {
    return _.map(this.props.admissionBoard, (data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.ShortName + " (" + data.BoardName + ")"}
        </option>
      );
    });
  };

  handleMarksTypeChange = (Qualification_ID, column, e, MarksTypeId) => {
    this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0][column] = parseInt(e.target.value, 10);
    this.setState({ refresh: !this.state.refresh });
  };
  renderMarksType = () => {
    return _.map(this.props.admissionMarksType, (data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.MarksType}
        </option>
      );
    });
  };

  onMonthPickerInputChange = (
    Qualification_ID,
    column,
    ename,
    PassingMonthYear
  ) => {
    this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0][column] = ename;
    this.setState({ refresh: !this.state.refresh });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    var isFormFeesPaidByStd = 0,
      isLocked = 0;
    var objFormFeesPaidByStd = this.props.admissionStudentStatusDetails.filter(
      (i) => {
        return (
          parseInt(i.AdmFormGroupId, 10) === parseInt(this.props.FormId, 10)
        );
      }
    );
    if (objFormFeesPaidByStd.length > 0) {
      isFormFeesPaidByStd = objFormFeesPaidByStd[0].IsFormFeesPaid;
      isLocked = objFormFeesPaidByStd[0].IsLocked;
    }

    var allDocument = this.state.allDocumentList.filter((item) => item.file);
    allDocument.map((item) => {
      return (item.ref = null);
    });

    var academicProfile = {
      StudentId: parseInt(this.props.auth.userId, 10),
      AdmFormId: parseInt(this.props.FormId, 10),
      ProgramsData: this.state.selectedPrograms.map((i, index) => {
        i.PreferredOrder = index + 1;
        return i;
      }),
      AdmissionType: parseInt(this.state.admissionTypeId, 10),
      OtherDetailId: this.state.otherDetailId,
      Qualification: this.state.allQualification,
      SubjectGroup: this.state.allSubjectGroup,
      ExperienceData: this.state.allExperienceData,
      ResearchData: this.state.allResearchData,
      NameOfDepartment: this.state.nameOfDepartment,
      Institution: this.state.institution,
      DateOfAppointment:
        this.state.dateOfAppointment !== undefined
          ? moment(this.state.dateOfAppointment).format("YYYY-MM-DD")
          : null,
      InstituteId: this.props.admissionWorkingDetails.Id,
      Designation: this.state.designation,
      PeriodOfService: this.state.periodOfService,
      IsNOCenclosed: this.state.isNOCenclosed,
      ProposedArea: this.state.proposedArea,

      RegistrationNo: this.state.registrationNo,
      MeritNo: this.state.meritNo,
      acpcId: this.state.acpcId,
      ApplyAllQuota: this.state.selectedQuota,

      IsHostel: this.state.isHostel,
      IsTransport: this.state.isTransport,
      DocumentList: allDocument,
      IsActive: 1,
      IsDelete: false,
      CreatedBy: this.props.auth.userId,
      UpdatedBy: this.props.auth.userId,
      IsFormFeesPaid: isFormFeesPaidByStd,
      IsLocked: isLocked,
    };
    //console.log("academicProfile", academicProfile);
    if (this.state.selectedPrograms.length > 0) {
      this.props.admissionAcademicProfileInsert(academicProfile);
      this.setState({ programRequired: false });
    } else {
      this.setState({ programRequired: true });
    }
  };

  componentDidUpdate() {
    updateGrid(this);
  }

  render() {
    if (this.props.update.redirectTab) {
      return (
        <Redirect
          to={`/Account/StudentAccount/AdmissionForm/3/${this.props.FormId}`}
        />
      );
    }
    return (
      <div>
        <div className="main-bg">
          <Form
            onSubmit={this.handleSubmit.bind(this)}
            ref={(c) => {
              this.form = c;
            }}
            className="textTransCapitalize"
          >
            <p className="text-center mb-0">
              Rows marked with asterisk ( <label className="required" /> ) are
              mandatory
            </p>

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 1
            ).length > 0 && (
              <div>
                {this.state.admissionProgram.length > 0 && (
                  <div>
                    <h2 className="page-title sub-title">Preferred Courses</h2>
                    <div className="row">
                      <div className="form-group  col-sm-4 col-lg-3">
                        <label className="required">Admission Type</label>
                        <select
                          onChange={this.handleAdmissionTypeChange}
                          id="admissionTypeId"
                          name="admissionTypeId"
                          className="form-control"
                          value={this.state.admissionTypeId}
                          validations={[validations.requiredSelect]}
                          label="Gender"
                        >
                          {this.renderAdmissionType()}
                        </select>
                      </div>
                      <div className="form-group col-sm-8 col-lg-9">
                        <label className="required">
                          Select Courses{" "}
                          <span style={{ fontSize: "10px" }}>
                            (You can select Multiple Courses from the list
                            below)
                          </span>
                        </label>
                        <SelectAdvance
                          id="programId"
                          name="programId"
                          multi
                          className="advanceSelect"
                          onChange={this.handleProgramsChange}
                          label="Courses"
                          value={this.state.selectedPrograms}
                          options={this.state.admissionProgram}
                        />
                        {this.state.programRequired && (
                          <span className="require_field">
                            Program is Required
                          </span>
                        )}
                      </div>
                    </div>{" "}
                  </div>
                )}
                {this.state.selectedPrograms.length > 0 && (
                  <h5 className="draglist-title">
                    Set your preference in order{" "}
                    <small>(Drag Courses up/down to set order)</small>
                  </h5>
                )}
                {this.state.selectedPrograms.length > 0 && (
                  <div className="draglist-group">
                    <DragDropContext onDragEnd={this.onDragEnd}>
                      <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                          >
                            {this.state.selectedPrograms.map((item, index) => (
                              <Draggable
                                key={item.value}
                                draggableId={item.value}
                                index={index}
                                isDragDisabled={
                                  item.AdmOpenCloseStatus ? true : false
                                }
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    className="draglist-group-item"
                                    style={getItemStyle(
                                      snapshot.isDragging,
                                      provided.draggableProps.style
                                    )}
                                  >
                                    <i
                                      className="fa fa-bars"
                                      aria-hidden="true"
                                    />
                                    {item.label}
                                    <span className="badge badge-primary">
                                      {index + 1}
                                    </span>
                                    <i
                                      onClick={this.removeSelectedProgram.bind(
                                        this,
                                        index
                                      )}
                                      className="fa fa-remove float-right"
                                    />
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                )}

                {_.sortBy(this.state.allQualification, "SeqNo").filter(
                  (i) => !i.IsCet
                ).length > 0 && (
                  <div className="mb-4">
                    <h2 className="page-title sub-title">
                      Enter Qualification Details
                    </h2>
                    <table className="table table-bordered qulification-table">
                      <thead className="table-light">
                        <tr>
                          <th
                            style={{ width: "180px" }}
                            className="align-middle"
                          >
                            Degree
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "100px" }}
                          >
                            Stream
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "90px" }}
                          >
                            Month-Year
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "120px" }}
                          >
                            Board
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "190px" }}
                          >
                            Institute/University
                          </th>

                          <th
                            className="align-middle"
                            style={{ width: "80px" }}
                          >
                            Medium
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "130px" }}
                          >
                            Marks Type
                          </th>

                          <th
                            className="align-middle"
                            style={{ width: "60px" }}
                          >
                            Scored
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "90px" }}
                          >
                            Max Marks
                          </th>

                          <th
                            className="align-middle"
                            style={{ width: "15px" }}
                          >
                            Attempt
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {_.sortBy(this.state.allQualification, "SeqNo")
                          .filter((i) => !i.IsCet)
                          .map((qualification, qualIndex) => {
                            return (
                              <tr
                                key={qualIndex}
                                className="acInfoIsCompulsory"
                              >
                                <td className="align-middle">
                                  {qualification.IsCompulsory === 1 ? (
                                    <label className="required">
                                      {qualification.Adm_QualficationName}
                                    </label>
                                  ) : (
                                    <span>
                                      {qualification.Adm_QualficationName}
                                    </span>
                                  )}
                                </td>
                                <td className="align-middle">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="StreamName"
                                    name="StreamName"
                                    label="Stream"
                                    placeholder="Stream"
                                    value={qualification.StreamName || ""}
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "StreamName"
                                    )}
                                  />
                                </td>
                                <td className="align-middle ">
                                  <Input
                                    type="text"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.PassingMonthYear
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    id="PassingMonthYear"
                                    name="StreaPassingMonthYearmName"
                                    label="Month-Year"
                                    placeholder="MM/YYYY"
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.required]
                                        : []
                                    }
                                    value={qualification.PassingMonthYear || ""}
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "PassingMonthYear"
                                    )}
                                  />
                                </td>
                                <td className="align-middle">
                                  <Select
                                    onChange={this.handleBoardChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "University_Board"
                                    )}
                                    id="University_Board"
                                    name="University_Board"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      parseInt(
                                        qualification.University_Board
                                      ) === 0
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    value={qualification.University_Board || 0}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.requiredSelect]
                                        : []
                                    }
                                    label="Board"
                                  >
                                    <option value="0">Select Board</option>
                                    {this.renderBoard()}
                                  </Select>
                                </td>
                                <td className="align-middle">
                                  <Input
                                    type="text"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.InstituteName
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    id="InstituteName"
                                    name="InstituteName"
                                    label="InstituteName"
                                    placeholder="Institute Name"
                                    value={qualification.InstituteName || ""}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.required]
                                        : []
                                    }
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "InstituteName"
                                    )}
                                  />
                                </td>
                                <td className="align-middle">
                                  <Input
                                    type="text"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.Medium
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    id="Medium"
                                    name="Medium"
                                    label="Medium"
                                    placeholder="Medium"
                                    value={qualification.Medium || ""}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.required]
                                        : []
                                    }
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "Medium"
                                    )}
                                  />
                                </td>
                                <td className="align-middle">
                                  <Select
                                    onChange={this.handleMarksTypeChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "MarksTypeId"
                                    )}
                                    id="MarksTypeId"
                                    name="MarksTypeId"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      parseInt(qualification.MarksTypeId) === 0
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    value={qualification.MarksTypeId || 0}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.requiredSelect]
                                        : []
                                    }
                                    label="MarksType"
                                  >
                                    <option value="0">Select MarksType</option>
                                    {this.renderMarksType()}
                                  </Select>
                                </td>
                                <td className="align-middle">
                                  <Input
                                    type="text"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.Percentage_Grade
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    id="Percentage_Grade"
                                    name="Percentage_Grade"
                                    label="Scored"
                                    placeholder="Scored"
                                    value={qualification.Percentage_Grade || ""}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.required]
                                        : []
                                    }
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "Percentage_Grade"
                                    )}
                                  />
                                </td>
                                <td className="align-middle">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="PercentageOutOf"
                                    name="PercentageOutOf"
                                    label="Max Marks"
                                    placeholder="Max Marks"
                                    value={
                                      Math.round(
                                        qualification.PercentageOutOf
                                      ) || ""
                                    }
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "PercentageOutOf"
                                    )}
                                  />
                                </td>
                                <td className="align-middle">
                                  <Input
                                    type="number"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.Attempts
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    id="Attempts"
                                    name="Attempts"
                                    label="Attempts"
                                    placeholder="#Attempts"
                                    value={qualification.Attempts || ""}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.required]
                                        : []
                                    }
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "Attempts"
                                    )}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <hr />
                  </div>
                )}

                {_.sortBy(this.state.allQualification, "SeqNo").filter(
                  (i) => !i.IsCet && i.ShowInDetailTable === 1
                ).length > 0 && (
                  <div>
                    {_.sortBy(this.state.allQualification, "SeqNo")
                      .filter((i) => !i.IsCet && i.ShowInDetailTable === 1)
                      .map((qualification, qualIndex) => {
                        return (
                          <div key={qualIndex}>
                            <h5 className="inner-title mb-3 mt-2">
                              {qualification.Adm_QualficationName} Subject
                              Details{" "}
                              {/* <strong>
                                (In marks cards containing non segregated theory
                                &amp; practical marks, enter total marks in
                                theory field &amp; '0' in practical field)
                              </strong> */}
                              <strong>
                                (In marks cards containing non segregated theory
                                &amp; practical marks, enter total marks in
                                theory field &amp; 'Leave blank' in practical
                                field)
                              </strong>
                            </h5>
                            <table className="table table-bordered qulification-table">
                              <thead className="table-light">
                                <tr>
                                  <th
                                    rowSpan="2"
                                    className="align-middle"
                                    style={{ width: "250px" }}
                                  >
                                    Subjects
                                  </th>
                                  <th
                                    colSpan="2"
                                    className="align-middle text-center"
                                  >
                                    Theory
                                  </th>
                                  <th
                                    colSpan="2"
                                    className="align-middle text-center"
                                  >
                                    Practical
                                  </th>
                                  <th
                                    rowSpan="2"
                                    className="align-middle text-center"
                                    style={{ width: "160px" }}
                                  >
                                    Total
                                  </th>
                                </tr>
                                <tr className="text-center">
                                  <th className="align-middle">Max Marks</th>
                                  <th className="align-middle">Marks Scored</th>
                                  <th className="align-middle">Max Marks</th>
                                  <th className="align-middle">Marks Scored</th>
                                </tr>
                              </thead>
                              <tbody>
                                {qualification.subjectList.map(
                                  (subject, subjectIndex) => {
                                    return (
                                      <tr key={subjectIndex}>
                                        <td className="align-middle">
                                          {subject.Qual_Subjects}
                                        </td>
                                        <td className="align-middle text-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="MarksTotal_Theory"
                                            name="MarksTotal_Theory"
                                            label="Max Marks"
                                            placeholder="Max Marks"
                                            value={
                                              Math.round(
                                                subject.MarksTotal_Theory
                                              ) || ""
                                            }
                                            onChange={this.onInputSubjectChange.bind(
                                              this,
                                              subject.Qualification_ID,
                                              subject.Qual_SubjectID,
                                              "MarksTotal_Theory"
                                            )}
                                          />
                                        </td>
                                        <td className="align-middle text-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="MarksScored_Theory"
                                            name="MarksScored_Theory"
                                            label="Max Scored"
                                            placeholder="Max Scored"
                                            value={
                                              Math.round(
                                                subject.MarksScored_Theory
                                              ) || ""
                                            }
                                            onChange={this.onInputSubjectChange.bind(
                                              this,
                                              subject.Qualification_ID,
                                              subject.Qual_SubjectID,
                                              "MarksScored_Theory"
                                            )}
                                          />
                                        </td>
                                        <td className="align-middle text-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="MarksTotal_Practical"
                                            name="MarksTotal_Practical"
                                            label="Max Marks"
                                            placeholder="Max Marks"
                                            value={
                                              Math.round(
                                                subject.MarksTotal_Practical
                                              ) || ""
                                            }
                                            onChange={this.onInputSubjectChange.bind(
                                              this,
                                              subject.Qualification_ID,
                                              subject.Qual_SubjectID,
                                              "MarksTotal_Practical"
                                            )}
                                          />
                                        </td>
                                        <td className="align-middle text-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="MarksScored_Practical"
                                            name="MarksScored_Practical"
                                            label="Max Scored"
                                            placeholder="Max Scored"
                                            value={
                                              Math.round(
                                                subject.MarksScored_Practical
                                              ) || ""
                                            }
                                            onChange={this.onInputSubjectChange.bind(
                                              this,
                                              subject.Qualification_ID,
                                              subject.Qual_SubjectID,
                                              "MarksScored_Practical"
                                            )}
                                          />
                                        </td>
                                        <td className="align-middle text-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="TotalScored"
                                            name="TotalScored"
                                            label="Total"
                                            placeholder="Total"
                                            value={
                                              Math.round(subject.TotalScored) ||
                                              ""
                                            }
                                            onChange={this.onInputSubjectChange.bind(
                                              this,
                                              subject.Qualification_ID,
                                              subject.Qual_SubjectID,
                                              "TotalScored"
                                            )}
                                          />
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        );
                      })}
                    <hr />
                  </div>
                )}

                {_.sortBy(this.state.allQualification, "SeqNo").filter(
                  (i) => i.IsCet
                ).length > 0 && (
                  <div>
                    <h2 className="page-title sub-title">
                      Enter Examination Details
                    </h2>
                    {_.sortBy(this.state.allQualification, "SeqNo")
                      .filter((i) => i.IsCet)
                      .map((qualification, qualIndex) => {
                        return (
                          <div key={qualIndex}>
                            <h5 className="inner-title mb-3 mt-1">
                              {qualification.Adm_QualficationName} Details
                            </h5>
                            <table className="table table-bordered qulification-table">
                              <thead className="table-light">
                                <tr>
                                  <th className="align-middle">Examination</th>
                                  <th className="align-middle">Reg. Number</th>
                                  <th className="align-middle">
                                    Marks Obtained
                                  </th>
                                  <th className="align-middle">Marks Out OF</th>
                                  <th className="align-middle">
                                    Percentile Score
                                  </th>
                                  <th className="align-middle">Rank</th>
                                  <th className="align-middle">
                                    Caste-Category Rank
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="align-middle">
                                    {qualification.Adm_QualficationName}
                                  </td>
                                  <td className="align-middle">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="seatNumber"
                                      name="seatNumber"
                                      label="seatNumber"
                                      placeholder="Reg. Number"
                                      value={qualification.SeatNo || ""}
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "SeatNo"
                                      )}
                                    />
                                  </td>
                                  <td className="align-middle">
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="Percentage_Grade"
                                      name="Percentage_Grade"
                                      label="Marks/Grade"
                                      placeholder="Marks Obtained"
                                      value={
                                        parseFloat(
                                          qualification.Percentage_Grade
                                        ) || ""
                                      }
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "Percentage_Grade"
                                      )}
                                    />
                                  </td>
                                  <td className="align-middle">
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="PercentageOutOf"
                                      name="PercentageOutOf"
                                      label="Max Marks"
                                      placeholder="Marks Out OF"
                                      value={
                                        qualification.PercentageOutOf || ""
                                      }
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "PercentageOutOf"
                                      )}
                                    />
                                  </td>
                                  <td className="align-middle">
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="PercentileScore"
                                      name="PercentileScore"
                                      label="PercentileScore"
                                      placeholder="Percentile Score"
                                      value={qualification.Percentile || ""}
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "Percentile"
                                      )}
                                    />
                                  </td>
                                  <td className="align-middle">
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="AllIndiaRank"
                                      name="AllIndiaRank"
                                      label="All India Rank(Overall)"
                                      placeholder="Rank"
                                      value={qualification.Rank || ""}
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "Rank"
                                      )}
                                    />
                                  </td>
                                  <td className="align-middle">
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="CategoryRank"
                                      name="CategoryRank"
                                      label="Category Rank"
                                      placeholder="Caste-Category Rank"
                                      value={qualification.CategoryRank || ""}
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "CategoryRank"
                                      )}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {qualification.IsCet &&
                              qualification.ShowInDetailTable === 1 && (
                                <div>
                                  <h5 className="inner-title mb-3 mt-2">
                                    {qualification.Adm_QualficationName} Subject
                                    Details{" "}
                                    {/* <strong>
                                      (In marks cards containing non segregated
                                      theory &amp; practical marks, enter total
                                      marks in theory field &amp; '0' in
                                      practical field)
                                    </strong> */}
                                    <strong>
                                      (In marks cards containing non segregated
                                      theory &amp; practical marks, enter total
                                      marks in theory field &amp; 'Leave blank'
                                      in practical field)
                                    </strong>
                                  </h5>
                                  <table className="table table-bordered qulification-table">
                                    <thead className="table-light">
                                      <tr>
                                        <th
                                          rowSpan="2"
                                          className="align-middle"
                                          style={{ width: "250px" }}
                                        >
                                          Subjects
                                        </th>
                                        <th className="align-middle text-center">
                                          Max Marks
                                        </th>
                                        <th className="align-middle text-center">
                                          Marks Scored
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {qualification.subjectList.map(
                                        (subject, subjectIndex) => {
                                          return (
                                            <tr key={subjectIndex}>
                                              <td className="align-middle">
                                                {subject.Qual_Subjects}
                                              </td>
                                              <td className="align-middle">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  id="MarksTotal_Theory"
                                                  name="MarksTotal_Theory"
                                                  label="Max Marks"
                                                  placeholder="Max Marks"
                                                  value={
                                                    subject.MarksTotal_Theory ||
                                                    ""
                                                  }
                                                  onChange={this.onInputSubjectChange.bind(
                                                    this,
                                                    subject.Qualification_ID,
                                                    subject.Qual_SubjectID,
                                                    "MarksTotal_Theory"
                                                  )}
                                                />
                                              </td>
                                              <td className="align-middle">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  id="MarksScored_Theory"
                                                  name="MarksScored_Theory"
                                                  label="Max Scored"
                                                  placeholder="Max Scored"
                                                  value={
                                                    subject.MarksScored_Theory ||
                                                    ""
                                                  }
                                                  onChange={this.onInputSubjectChange.bind(
                                                    this,
                                                    subject.Qualification_ID,
                                                    subject.Qual_SubjectID,
                                                    "MarksScored_Theory"
                                                  )}
                                                />
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                  <hr />
                                </div>
                              )}
                          </div>
                        );
                      })}
                  </div>
                )}

                {/* SubjectGroup List */}
                {this.state.allSubjectGroup.length > 0 && (
                  <div className="row">
                    <div className="col-sm-12">
                      <h5 className="inner-title mb-3 mt-1">
                        Subject Group Details
                      </h5>
                      <div className="row">
                        {this.state.allSubjectGroup.map(
                          (subjectGroup, subIndex) => {
                            return (
                              <div className="col-sm-4" key={subIndex}>
                                <table className="table table-bordered qulification-table">
                                  <thead className="table-light">
                                    <tr>
                                      <th
                                        className="align-middle"
                                        style={{ width: "250px" }}
                                      >
                                        Group
                                      </th>
                                      <th
                                        className="align-middle"
                                        style={{ width: "160px" }}
                                      >
                                        Total
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="align-middle">
                                        {subjectGroup.MeritSubjGroupName}
                                      </td>
                                      <td className="align-middle">
                                        <input
                                          type="number"
                                          className="form-control"
                                          id="TotalScored"
                                          name="TotalScored"
                                          label="Total"
                                          placeholder="Total"
                                          value={
                                            Math.round(
                                              subjectGroup.TotalScored
                                            ) || ""
                                          }
                                          onChange={this.onInputSubjectGroupChange.bind(
                                            this,
                                            subjectGroup.SubGroupId,
                                            "TotalScored"
                                          )}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 14
            ).length > 0 ||
            this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 15
            ).length > 0 ? (
              <div>
                <h4 className="page-title sub-title">ACPC Details</h4>
                <div className="row ">
                  {this.props.admissionFormConfiguration.filter(
                    (i) =>
                      i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 14
                  ).length > 0 && (
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>ACPC Registration No</label>
                        <input
                          type="text"
                          className="form-control"
                          id="registrationNo"
                          value={this.state.registrationNo || ""}
                          name="registrationNo"
                          label="ACPC Registration No"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                  )}
                  {this.props.admissionFormConfiguration.filter(
                    (i) =>
                      i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 15
                  ).length > 0 && (
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>ACPC Merit No</label>
                        <input
                          type="text"
                          className="form-control"
                          id="meritNo"
                          value={this.state.meritNo || ""}
                          name="meritNo"
                          label="ACPC Merit No"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 2
            ).length > 0 && (
              <div>
                <h4 className="page-title sub-title">Experience Details</h4>
                <div className="row mb-4">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Position</label>
                      <input
                        type="text"
                        className="form-control"
                        id="position"
                        value={textToCapitalize(this.state.position) || ""}
                        name="position"
                        label="Position"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Organisation</label>
                      <input
                        type="text"
                        className="form-control"
                        id="organisation"
                        value={textToCapitalize(this.state.organisation) || ""}
                        name="organisation"
                        label="Organisation"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Assignment</label>
                      <input
                        type="text"
                        className="form-control"
                        id="workDetails"
                        value={textToCapitalize(this.state.workDetails) || ""}
                        name="workDetails"
                        label="Assignment"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Period</label>
                      <input
                        type="number"
                        className="form-control"
                        id="workDuration"
                        value={this.state.workDuration || ""}
                        name="workDuration"
                        label="Period"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 flexMiddel flex15">
                    <button
                      type="button"
                      className="btn btn-success btn-md marg30 theme-btn"
                      onClick={this.addExperienceData.bind()}
                    >
                      <i className="fa fa-plus" />
                      Add
                    </button>
                  </div>
                  <div className="col-lg-12">
                    <table className="table table-bordered qulification-table mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="align-middle">Position</th>
                          <th className="align-middle">Organisation</th>
                          <th className="align-middle">Assignment</th>
                          <th className="align-middle">Period</th>
                          <th className="align-middle" width="50px">
                            Remove
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.allExperienceData.map((item, index) => {
                          return (
                            item.Position !== undefined && item.Position !== "",
                            item.Organisation !== undefined &&
                              item.Organisation !== "" &&
                              item.WorkDetails !== undefined &&
                              item.WorkDetails !== "",
                            item.WorkDuration !== undefined &&
                            item.WorkDuration !== "" ? (
                              <tr key={index}>
                                <td className="align-middle">
                                  {item.Position}
                                </td>
                                <td className="align-middle">
                                  {item.Organisation}
                                </td>
                                <td className="align-middle">
                                  {item.WorkDetails}
                                </td>
                                <td className="align-middle">
                                  {item.WorkDuration}
                                </td>
                                <td className="text-center align-middle">
                                  <button
                                    className="btn btn-xs btn-danger theme-btn"
                                    onClick={this.experienceConfigDelete.bind(
                                      this,
                                      index
                                    )}
                                    type="button"
                                  >
                                    <i className="fa fa-trash" />
                                  </button>
                                </td>
                              </tr>
                            ) : (
                              ""
                            )
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 3
            ).length > 0 && (
              <div>
                <h4 className="page-title sub-title">
                  Research Details (If PHD)
                </h4>
                <div className="row mb-4">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Title/Publication </label>
                      <input
                        type="text"
                        className="form-control"
                        id="publication"
                        value={textToCapitalize(this.state.publication) || ""}
                        name="publication"
                        label="Publication"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Name of Journal</label>
                      <input
                        type="text"
                        className="form-control"
                        id="nameofJournal"
                        value={textToCapitalize(this.state.nameofJournal) || ""}
                        name="nameofJournal"
                        label="Name of Journal"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Vol/Edition </label>
                      <input
                        type="text"
                        className="form-control"
                        id="volEdition"
                        value={this.state.volEdition || ""}
                        name="volEdition"
                        label="Vol/Edition"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>National/International </label>
                      <input
                        type="text"
                        className="form-control"
                        id="researchType"
                        value={textToCapitalize(this.state.researchType) || ""}
                        name="researchType"
                        label="National/International"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 flexMiddel flex15">
                    <button
                      type="button"
                      className="btn btn-success btn-md marg30 theme-btn"
                      onClick={this.addResearchData.bind()}
                    >
                      <i className="fa fa-plus" />
                      Add
                    </button>
                  </div>
                  <div className="col-lg-12">
                    <table className="table table-bordered qulification-table mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="align-middle">Title/Publication</th>
                          <th className="align-middle">Name of Journal</th>
                          <th className="align-middle">Vol/Edition</th>
                          <th className="align-middle">
                            National/International
                          </th>
                          <th className="align-middle" width="50px">
                            Remove
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.allResearchData.map((item, index) => {
                          return (
                            item.PublicationTitle !== undefined &&
                              item.PublicationTitle !== "",
                            item.JournalName_Published !== undefined &&
                              item.JournalName_Published !== "",
                            item.No_Vol_Edition_Date !== undefined &&
                              item.No_Vol_Edition_Date !== "",
                            item.ResearchType !== undefined &&
                            item.ResearchType !== "" ? (
                              <tr key={index}>
                                <td className="align-middle">
                                  {item.PublicationTitle}
                                </td>
                                <td className="align-middle">
                                  {item.JournalName_Published}
                                </td>
                                <td className="align-middle">
                                  {item.No_Vol_Edition_Date}
                                </td>
                                <td className="align-middle">
                                  {item.ResearchType}
                                </td>
                                <td className="text-center align-middle">
                                  <button
                                    className="btn btn-xs btn-danger theme-btn"
                                    onClick={this.researchConfigDelete.bind(
                                      this,
                                      index
                                    )}
                                    type="button"
                                  >
                                    <i className="fa fa-trash" />
                                  </button>
                                </td>
                              </tr>
                            ) : (
                              ""
                            )
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 3
            ).length > 0 && (
              <div className="mb-3">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>
                        Proposed Research Area / Title for Ph.D Studies
                      </label>
                      <textarea
                        type="text"
                        rows="3"
                        className="form-control"
                        id="proposedArea"
                        name="proposedArea"
                        label="Proposed Research Area / Title for Ph.D Studies"
                        value={textToCapitalize(this.state.proposedArea) || ""}
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 5
            ).length > 0 && (
              <div>
                <h5 className="inner-title  mb-4">
                  Details of In-service Candidates (for those working in
                  Institute)
                </h5>
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Name Of The Department</label>
                      <input
                        type="text"
                        className="form-control"
                        id="nameOfDepartment"
                        value={
                          textToCapitalize(this.state.nameOfDepartment) || ""
                        }
                        name="nameOfDepartment"
                        label="Department"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Name Of The Institution/College</label>
                      <input
                        type="text"
                        className="form-control"
                        id="institution"
                        value={textToCapitalize(this.state.institution) || ""}
                        name="institution"
                        label="Institution/College"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Date Of Appointment</label>
                      <DatePicker
                        selected={this.state.dateOfAppointment}
                        onChange={this.appointmentDate}
                        showYearDropdown
                        showMonthDropdown
                        className="form-control"
                        label="Date Of Appointment"
                        dateFormat={this.props.systemConfig.DateFormat}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Present Designation</label>
                      <input
                        type="text"
                        className="form-control"
                        id="designation"
                        value={textToCapitalize(this.state.designation) || ""}
                        name="designation"
                        label="Present Designation"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Period of Service</label>
                      <input
                        type="number"
                        className="form-control"
                        id="periodOfService"
                        value={this.state.periodOfService || ""}
                        name="periodOfService"
                        label="Period of Service"
                        onChange={this.onInputChange}
                        //validations={[validations.required]}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Is NOC Enclosed?</label>
                      <br />
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={this.state.isNOCenclosed ? true : false}
                          name="isNOCenclosed"
                          onChange={this.onSwitchToggle}
                        />
                        <span className="slider round" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 6
            ).length > 0 && (
              <div>
                <h2 className="page-title sub-title">Other Details</h2>
                <div className="row mb-3">
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Applying Through</label>
                      <SelectAdvance
                        id="selectedQuota"
                        name="selectedQuota"
                        multi
                        className="advanceSelect"
                        onChange={this.handleQuotaChange}
                        label="Quota"
                        value={this.state.selectedQuota}
                        options={this.state.academicQuota}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Do you need Hostel Accommodation?</label>
                      <br />
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={this.state.isHostel ? true : false}
                          name="isHostel"
                          onChange={this.onSwitchToggle}
                        />
                        <span className="slider round" />
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Do you need Transport Facility?</label>
                      <br />
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={this.state.isTransport ? true : false}
                          name="isTransport"
                          onChange={this.onSwitchToggle}
                        />
                        <span className="slider round" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 4
            ).length > 0 && (
              <div>
                <h2 className="page-title sub-title">Document Check List</h2>{" "}
                <span className="noteTextRed">
                  Maximum file size to upload 500KB
                </span>
                <table className="table table-bordered qulification-table mb-4">
                  <thead className="table-light">
                    <tr>
                      <th className="align-middle">Document Name</th>
                      <th className="align-middle">Uploaded Document</th>
                      <th className="align-middle">Upload Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.allDocumentList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td
                            className="align-middle filesDocumentName"
                            style={{ width: "450px" }}
                          >
                            <label
                              className="checkbox-inline"
                              htmlFor={item.DocumentCheckListName + index}
                            >
                              {item.DocumentCheckListName}
                            </label>
                            {item.documentFlag === 1 && (
                              <span className="required-docs " />
                            )}
                          </td>
                          <td className="align-middle ">
                            {item.UploadedDocName !== "" && (
                              <a
                                href={keys.ServicePath + item.UploadedDocPath}
                                download="filename"
                                target="_blank"
                                className="download-file"
                              >
                                <span className="uploadDocFileName">
                                  {item.UploadedDocName}{" "}
                                  <i
                                    className="fa fa-cloud-download"
                                    aria-hidden="true"
                                  />
                                </span>
                              </a>
                            )}
                          </td>
                          <td
                            style={{ width: "250px" }}
                            className="align-middle "
                          >
                            <div className="documentBrowse">
                              {/* FileInput */}
                              <FileInput
                                className="form-control-file"
                                id={"file" + index}
                                ref={(c) => {
                                  this["file" + index] = c;
                                }}
                                aria-describedby="fileHelp"
                                name={"file" + index}
                                label="File"
                                validations={
                                  item.documentFlag === 1 &&
                                  !item.UploadedDocPath
                                    ? [
                                        validations.required,
                                        validations.filesize(512000),
                                      ]
                                    : [validations.filesize(512000)]
                                }
                                fileSize={
                                  this.state["file" + index + "fileSize"]
                                }
                                onChange={this.handleFileBrowseChange.bind(
                                  this,
                                  index
                                )}
                                accept="doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            {this.props.admissionFormConfiguration.length > 0 && (
              <div className="row">
                <div className="col-lg-12">
                  <NavLink
                    className="btn btn-danger btn-lg theme-btn d-inline"
                    to={`/Account/StudentAccount/AdmissionForm/1/${this.props.FormId}`}
                  >
                    <i className="fa fa-angle-left" aria-hidden="true" />
                    Back
                  </NavLink>

                  {this.props.admissionFormConfiguration.length > 0 && (
                    <div className="d-inline">
                      {this.props.admissionFormList.length > 0 &&
                      this.props.admissionFormList.filter((i) => {
                        return (
                          i.ID === parseInt(this.props.FormId, 10) &&
                          i.IsVerify === 1 &&
                          i.IsActive === 0
                        );
                      }).length > 0 ? (
                        <Link
                          to={`/Account/StudentAccount/AdmissionForm/3/${this.props.FormId}`}
                          className="btn btn-success btn-lg theme-btn"
                        >
                          <i className="fa fa-save" />
                          Save
                        </Link>
                      ) : (
                        <Button
                          type="submit"
                          className="btn btn-success btn-lg theme-btn"
                        >
                          <i className="fa fa-save" />
                          Save
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </Form>
        </div>
      </div>
    );
  }
}

function mapStateToProps({
  auth,
  update,
  qualificationConfigList,
  systemConfig,
  documentChecklist,
  quotaList,
  admissionProgram,
  admissionFormConfiguration,
  admissionSubjectGroupList,
  admissionExperienceDetails,
  admissionOtherDetails,
  admissionResearchDetails,
  admissionWorkingDetails,
  academicQuotaList,
  admissionVerifyDetails,
  admissionApplyThrough,
  admissionBoard,
  admissionMarksType,
  admissionACPCdetails,
  admissionFormList,
  admissionStudentStatusDetails,
}) {
  return {
    auth,
    update,
    qualificationConfigList,
    systemConfig,
    documentChecklist,
    quotaList,
    admissionProgram,
    admissionFormConfiguration,
    admissionSubjectGroupList,
    admissionExperienceDetails,
    admissionOtherDetails,
    admissionResearchDetails,
    admissionWorkingDetails,
    academicQuotaList,
    admissionVerifyDetails,
    admissionApplyThrough,
    admissionBoard,
    admissionMarksType,
    admissionACPCdetails,
    admissionFormList,
    admissionStudentStatusDetails,
  };
}
export default connect(mapStateToProps, {
  clearUpdate,
  getQualificationConfigurationByFormId,
  getAllDocumentChecklistByFormId,
  admissionAcademicProfileInsert,
  getAllQuota,
  getAllAdmissionProgramByFormId,
  getAllAdmissionFormConfigurationByFormId,
  getAllAdmissionSubjectGroupByFormId,
  getWorkingInstituteDetailsByStudentId,
  getOtherDetailsByStudentId,
  getResearchDetailsByStudentId,
  getExperienceDetailsByStudentId,
  getAcademicQuotaDetailsByStudentId,
  getFormVerifyDetailsByStudentId,
  getAllApplyThroughList,
  getAllBoardList,
  getAllMarksTypeList,
  getACPCdetailsByStudentId,
  getAllAdmissionFormListByStudentId,
  getStudentStatusDetailsByUserId,
})(AcademicInfo);



// WEBPACK FOOTER //
// ./src/components/StudentAccount/AcademicInfo.js